export default {
	addAccount: '/mediafax/account', //新增账户
	editAccount: '/mediafax/account', //编辑账户
	getAuthUrl: '/mediafax/account/auth_url',
	getAccountList: '/mediafax/account/list', //账户列表
	getPlatFormAccount: '/mediafax/account/list_account', //根据平台获取已有的运营账号
	getGaList: '/sites/monitors/ga/account/list',
	getBdList: '/tongji/searchsite/', // 根据条件查询百度网址信息API
	googleaccount: '/sites/monitors/ga/mcc/account/list', // 获取GA账号信息集合API
	gtmaccount: '/sites/monitors/gtm/container/list', // 获取GTM账号信息集合API
};
